$(document).ready(function(){

	// -- slick --

	var sliderGallery = $('.slider__gallery');
	var sliderGallerySettings = {
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><span class="icon block sm:hidden rounded-full mx-auto sm:absolute"></span><span class="text sr-only">Previous</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="icon block sm:hidden rounded-full mx-auto sm:absolute"></span><span class="text sr-only">Next</span></button>',
	};
  sliderGallery.slick(sliderGallerySettings);


  // -- arrows --

  var arrowSize = 100/2;

  $('.slick-arrow').on('mouseover', function(e){
  	$(this).find('.icon').removeClass('sm:hidden').addClass('block');
  });
  $('.slick-arrow').on('mouseleave', function(e){
  	$(this).find('.icon').removeClass('block').addClass('sm:hidden');
  });
  $('.slick-arrow').on('mousemove', function(e){
  	var arrowOffset = $(this).offset();
  	$(this).find('.icon').css({
  		top: e.pageY - arrowOffset.top - arrowSize,
  		left: e.pageX - arrowOffset.left - arrowSize,
  	});
  });
});